import React, { FC } from 'react'

import { VipCrownSwitch } from 'components/block/NewYear/VipCrownSwitch'
import { giftIconSize } from 'components/page/UserProfile/UserProfileGifts/UserProfileGifts.constants'
import { ProfileAvatar } from 'components/presentational/ProfileAvatar/ProfileAvatar'

export const VipAvatar: FC<{
  photo: string | null | undefined
  size?: string | number
  type?: string
}> = ({ photo, size = giftIconSize, type = '' }) => {
  if (photo) {
    return <ProfileAvatar srcAvatar={photo} type={type} />
  }

  return <VipCrownSwitch width={size} height={size} />
}
